import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { Provider } from "react-redux";
import store from "./features/store";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from '@react-oauth/google';

import "./index.css";
import 'github-markdown-css/github-markdown-light.css';


// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import SubscriptionGate from "components/Subscribe/SubscriptionGate";
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("app");
const root = createRoot(container);
const helmetContext = {};

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
        <Provider store={store}>
          <SubscriptionGate>
            <Toaster />
              <HelmetProvider  context={helmetContext}>
                <App />
              </HelmetProvider>
          </SubscriptionGate>
        </Provider>
    </GoogleOAuthProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
